import React, { useState, useContext } from "react";
import "./login.css";
import { FaUser, FaLock, FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import axios from "axios";
import { useNavigate } from "react-router-dom";
const Login = () => {
  const { language } = useContext(LanguageContext);
  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => setShowPassword(!showPassword);
  const [userName, setUserName] = useState("");
  const [Password, setPassword] = useState("");
  const navigate = useNavigate();

  const ta = language === "ta";

  const labels = {
    title: "Login to your account",
    emailPhone: ta ? "தொலைபேசி" : " Mobile Number",
    emailPlaceholder: "Enter Your Phone",
    password: ta ? "கடவுச்சொல்" : "Password",
    passwordPlaceholder: "Password",
    rememberMe: ta ? "நினைவில் கொள்க" : "Remember Me",
    forgotPassword: "Forgot Password?",
    loginBtn: ta ? "உள்நுழைக" : "Login to your Account",
    noAccount: "Don't have an account?",
    createAccount: "Create an account",
  };

  const Submit = () => {
    if (userName.length != 10) {
      Notify.failure('Invalid mobile number');
      return;
    }
    if (!Password) {
      Notify.failure("password is required");
      return;
    }
    const data = {
      "mobile_number": userName,
      "password": Password

    }
    axios.post('https://kovaikongunadumatrimony.com/kkm_backend/public/api/login', data)
      .then(response => {
        if (response.data.status === true) {
          const UserToken = JSON.stringify(response.data.token);
          localStorage.setItem("kkm_auth", UserToken);
          Notify.success("Logged in successfully...");

          axios.get('https://kovaikongunadumatrimony.com/kkm_backend/public/api/user-payment-status', {
            headers: {
              Authorization: `Bearer ${response.data.token}`
            }
          })
            .then(res => {
              if (res.data.status === true) {
                navigate('/dashboard');
              } else {
                navigate('/pending-payment');
              }
            })
            .catch(error => {
              console.error("Error fetching payment status:", error);
              Notify.failure("Unable to fetch payment status!");
            });
        } else {
          Notify.failure(response.data.message || "Login failed!");
        }
      })
      .catch(error => {
        console.error("Login error:", error);
        Notify.failure("Something went wrong during login!");
      });

  }

  return (
    <>
      <TopNavbar />
      <Navbar />
      <div className="login-background">
        <div className="login-overlay">
          <div className="login-box">
            <h2>{labels.title}</h2>
            <form>
              <label htmlFor="username" className="mb-2">
                {labels.emailPhone}
                <span className="error fs-star">*</span>
              </label>
              <div className="input-box">
                <FaUser className="icon" />
                <input
                  type="text"
                  id="username"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder={labels.emailPlaceholder}
                  required
                />
              </div>

              <label htmlFor="password" className="mb-2">
                {labels.password}
                <span className="error fs-star">*</span>
              </label>
              <div className="input-box">
                <FaLock className="icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={Password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={labels.passwordPlaceholder}
                  required
                />
                <FaEye className="eye-icon" onClick={togglePassword} />
              </div>

              <div className="remember-forgot">
                <label>
                  <input type="checkbox" /> {labels.rememberMe}
                </label>
                {/* <Link
                  to={`/ForgotPassword?lang=${language}`} className="forgetlink">
                  {labels.forgotPassword}
                </Link> */}
              </div>

              <button type="button" onClick={Submit} className="login-btn">
                {labels.loginBtn}
              </button>

              <p className="signup-text">
                {labels.noAccount}{" "}
                <Link to={`/Register?lang=${language}`}>
                  {labels.createAccount}
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
